// extracted by mini-css-extract-plugin
export default {"link":"gHuJ8M","default":"AItHSW","dark":"Q2ZMSa","uppercase":"SGIgT3"};